var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('section',{staticClass:"section"},[_c('h4',{staticClass:"section__subheader"},[_vm._v("About me")])])])}]

export { render, staticRenderFns }